import { GridFilterModel } from "@mui/x-data-grid";
import { BeneColoreModel } from "../../models/api/response/bene/BeneColoreModel";
import {
  FetchPaginatedApiModel,
  WithData,
  WithRecordID,
} from "../../models/shared/CommonModels";
import { api_url } from "../../utils/ApiContext";
import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "../apiCommon";
import { SortingModel } from "../../models/shared/SortingModel";
import { appendStringFilterToUri } from "../../utils/filtering";

const TAKE_LIMIT = 15;

const setQueryParameters = (
  filter: GridFilterModel | undefined,
  sort: SortingModel
) => {
  let uri = api_url.concat("/api/colorebene?");

  filter?.items.forEach((item) => {
    uri = appendStringFilterToUri(item.field, "nome", item.value, uri);
  });

  uri = uri.concat("&sort_field=", sort.field.toString());
  uri = uri.concat("&sort_direction=", sort.direction.toString());

  uri = uri.endsWith("?") ? uri.concat("skip=") : uri.concat("&skip=");

  return uri;
};

const getBeneColori = (
  selectedId: number,
  page: number,
  sort: SortingModel,
  filter?: GridFilterModel
) => {
  let uri = setQueryParameters(filter, sort);

  let skip = 0;
  let take = TAKE_LIMIT;
  if (page > 0) skip = page * take;

  return getRequest<FetchPaginatedApiModel<BeneColoreModel[]>>(
    uri.concat(
      "&skip=",
      skip.toString(),
      "&take=",
      take.toString(),
      "&selectedId=",
      selectedId.toString()
    )
  );
};

const createColoreBene = (postdata: WithData) => {
  return postRequest(api_url.concat("/api/colorebene"), postdata.data);
};

const updateColore = (putdata: WithRecordID) => {
  return putRequest(
    api_url.concat("/api/colorebene/", putdata.recordID.toString()),
    putdata.data
  );
};

const deleteColore = (id: number) => {
  return deleteRequest(api_url.concat("/api/colorebene/", id.toString()));
};

export { createColoreBene, getBeneColori, updateColore, deleteColore };
